(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1721],{

/***/ 81783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ eticky_kodex_vzdelavania; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/EducationalCodeEthics/EducationalCodeEthics.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "EducationalCodeEthicselements__Wrapper",
  componentId: "sc-1nhn2se-0"
})(["margin-top:", ";padding:0 ", ";@media (min-width:", "px){margin-top:", ";}.title{font-size:", ";font-weight:", ";color:", ";display:block;text-align:center;padding-bottom:", ";margin-top:", ";}.subTitle{font-weight:", ";display:block;text-align:center;padding-bottom:", ";}h1.sectionTitle{font-size:", ";font-weight:", ";display:block;padding:", " 0;}h2.sectionTitle{font-size:", ";font-weight:", ";display:block;padding:", " 0;}.underline{text-decoration:underline;}.marginLeft{margin-left:", ";}.section{a{color:", ";padding-right:", ";display:inline-flex;}}"], (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(30), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(65), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(18), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(16), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(4));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/EducationalCodeEthics/EducationalCodeEthics.tsx




var EDUCATIONALCODEETHICS_ID = 'EducationalCodeEthics';

var EducationalCodeEthicsTemplate = function EducationalCodeEthicsTemplate() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "title",
      id: "".concat(EDUCATIONALCODEETHICS_ID, "-sekcia"),
      children: "Etick\xFD k\xF3dex pre oblas\u0165 person\xE1lneho zabezpe\u010Denia vzdel\xE1vacej \u010Dinnosti"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subTitle",
      children: "Poradca podnikate\u013Ea, s. r. o. \u2013 \xFAsek Vzdel\xE1vanie, platforma Profivzdel\xE1vanie.sk"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "\xDAvod"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Tento etick\xFD k\xF3dex stanovuje z\xE1v\xE4zn\xE9 pravidl\xE1 a etick\xE9 princ\xEDpy pre v\u0161etky osoby zapojen\xE9 do person\xE1lneho zabezpe\u010Denia vzdel\xE1vacej \u010Dinnosti v r\xE1mci platformy Profivzdel\xE1vanie spolo\u010Dnosti Poradca podnikate\u013Ea. Dokument vytv\xE1ra jednotn\xFD \u0161tandard pre v\xFDber, koordin\xE1ciu, odborn\xE9 vedenie, kontrolu a hodnotenie lektorov, garantov, intern\xFDch metodikov a administrat\xEDvnych pracovn\xEDkov."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "1. Poslanie a \xFA\u010Del k\xF3dexu"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Cie\u013Eom k\xF3dexu je:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zaisti\u0165 d\xF4veryhodnos\u0165, transparentnos\u0165 a profesionalitu vzdel\xE1vac\xEDch slu\u017Eieb,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "chr\xE1ni\u0165 \xFA\u010Dastn\xEDkov vzdel\xE1vania a podporova\u0165 f\xE9rov\xFD pr\xEDstup,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "stanovi\u0165 etick\xE9 \u0161tandardy pre v\u0161etky pracovn\xE9 role vo vzdel\xE1vacom procese,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "predch\xE1dza\u0165 konfliktom z\xE1ujmov a neetick\xE9mu spr\xE1vaniu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "2. Z\xE1kladn\xE9 hodnoty"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Profesionalita"
        }), " \u2013 kvalifikovan\xFD, odborn\xFD a zodpovedn\xFD v\xFDkon."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Nestrannos\u0165"
        }), " \u2013 rovnak\xE9 podmienky pre v\u0161etk\xFDch \xFA\u010Dastn\xEDkov."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Integrita"
        }), " \u2013 \u010Destnos\u0165, transparentnos\u0165, spo\u013Eahlivos\u0165."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Re\u0161pekt"
        }), " \u2013 \xFActa k \xFA\u010Dastn\xEDkom, kolegom, rozmanitosti a \u013Eudskej d\xF4stojnosti."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Odborn\xFD rast"
        }), " \u2013 priebe\u017En\xE9 vzdel\xE1vanie a zlep\u0161ovanie vlastn\xFDch kompetenci\xED."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "3. Etick\xE9 z\xE1sady pre lektorov"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kona\u0165 odborne, zodpovedne a v s\xFAlade s aktu\xE1lnymi poznatkami v odbore,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "re\u0161pektova\u0165 individu\xE1lne potreby \xFA\u010Dastn\xEDkov a podporova\u0165 inkluz\xEDvne prostredie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zaru\u010Di\u0165 pravdivos\u0165 a odbornos\u0165 inform\xE1ci\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dodr\u017Eiava\u0165 ml\u010Danlivos\u0165 o osobn\xFDch \xFAdajoch \xFA\u010Dastn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "spr\xE1va\u0165 sa kult\xFArne, profesion\xE1lne a f\xE9rovo,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "neprij\xEDma\u0165 dary alebo protislu\u017Eby za individu\xE1lne zv\xFDhodnenie \xFA\u010Dastn\xEDka."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "4. Etick\xE9 z\xE1sady pre garanta vzdel\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Dova\u0165 odborn\xFA \xFArove\u0148 obsahu a metodick\xFA spr\xE1vnos\u0165,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dohliada\u0165 na aktualiz\xE1ciu vzdel\xE1vac\xEDch materi\xE1lov a s\xFAlad s legislat\xEDvou,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kontrolova\u0165 pr\xE1cu lektorov a poskytova\u0165 im sp\xE4tn\xFA v\xE4zbu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vykon\xE1va\u0165 svoju \xFAlohu nestranne a bez konfliktu z\xE1ujmov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "5. Etick\xE9 z\xE1sady pre administrat\xEDvnu a organiza\u010Dn\xFA podporu"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poskytova\u0165 \xFA\u010Dastn\xEDkom presn\xE9 a pravdiv\xE9 inform\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Di\u0165 dostupnos\u0165 a komfort \xFA\u010Dastn\xEDkov po\u010Das cel\xE9ho vzdel\xE1vacieho procesu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zodpovedne chr\xE1ni\u0165 osobn\xE9 \xFAdaje a dokument\xE1ciu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "komunikova\u0165 trpezlivo, otvorene a profesion\xE1lne."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "6. Konflikt z\xE1ujmov"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Osoby zapojen\xE9 do vzdel\xE1vacej \u010Dinnosti s\xFA povinn\xE9:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyhn\xFA\u0165 sa situ\xE1ci\xE1m, v ktor\xFDch osobn\xFD z\xE1ujem m\xF4\u017Ee ovplyvni\u0165 profesion\xE1lne rozhodovanie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "ozn\xE1mi\u0165 potenci\xE1lny konflikt z\xE1ujmov garantovi alebo vedeniu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zdr\u017Ea\u0165 sa ak\xFDchko\u013Evek aktiv\xEDt, ktor\xE9 by mohli po\u0161kodi\u0165 d\xF4veryhodnos\u0165 platformy Profivzdel\xE1vanie.sk spolo\u010Dnosti Poradca podnikate\u013Ea."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "7. Pravidl\xE1 komunik\xE1cie a spr\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "komunik\xE1cia mus\xED by\u0165 zalo\u017Een\xE1 na \xFActe, pravdivosti a profesionalite,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pou\u017E\xEDvanie nevhodn\xE9ho jazyka, diskrimina\u010Dn\xFDch vyjadren\xED alebo prejavov je nepr\xEDpustn\xE9,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pracovn\xEDci musia dodr\u017Eiava\u0165 kult\xFArne normy a z\xE1sady bezpe\u010Dn\xE9ho pracovn\xE9ho prostredia."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "8. Ml\u010Danlivos\u0165 a ochrana \xFAdajov"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "v\u0161etky osobn\xE9 \xFAdaje \xFA\u010Dastn\xEDkov s\xFA d\xF4vern\xE9,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pracovn\xEDci musia postupova\u0165 v s\xFAlade s GDPR a intern\xFDmi smernicami o ochrane \xFAdajov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "inform\xE1cie z hodnoten\xED, testov \u010Di sp\xE4tnej v\xE4zby musia by\u0165 chr\xE1nen\xE9 pred zneu\u017Eit\xEDm."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "9. Profesionalita a odborn\xFD rozvoj"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "v\u0161etci zamestnanci a spolupracovn\xEDci s\xFA povinn\xED priebe\u017Ene aktualizova\u0165 svoje odborn\xE9 kompetencie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "profesijn\xE9 zlyhania musia by\u0165 rie\u0161en\xE9 kon\u0161trukt\xEDvne, s cie\u013Eom podpori\u0165 zlep\u0161enie."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "10. Etick\xE9 z\xE1sady pre v\xFDber a hodnotenie person\xE1lu"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "v\xFDber lektorov a garantov mus\xED by\u0165 transparentn\xFD, objekt\xEDvny a zalo\u017Een\xFD na preuk\xE1zate\u013En\xFDch kompetenci\xE1ch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "hodnotenie v\xFDkonu mus\xED by\u0165 spravodliv\xE9, vecn\xE9 a podlo\u017Een\xE9 merate\u013En\xFDmi ukazovate\u013Emi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "diskrimin\xE1cia z ak\xE9hoko\u013Evek d\xF4vodu je pr\xEDsne zak\xE1zan\xE1."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "11. Poru\u0161enie etick\xE9ho k\xF3dexu"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poru\u0161enie k\xF3dexu m\xF4\u017Ee vies\u0165 k disciplin\xE1rnym opatreniam, ukon\u010Deniu spolupr\xE1ce alebo in\xFDm z\xE1sahom,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "z\xE1va\u017En\xE9 poru\u0161enia m\xF4\u017Eu by\u0165 nahl\xE1sen\xE9 pr\xEDslu\u0161n\xFDm org\xE1nom,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "v\u0161etci pracovn\xEDci s\xFA zodpovedn\xED za nahl\xE1senie neetick\xE9ho spr\xE1vania."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "12. Roz\u0161\xEDren\xE9 etick\xE9 \u0161tandardy spr\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Tieto \u0161tandardy predstavuj\xFA z\xE1v\xE4zn\xE9 pravidl\xE1, ktor\xE9 musia dodr\u017Eiava\u0165 v\u0161etci pracovn\xEDci zapojen\xED do vzdel\xE1vac\xEDch aktiv\xEDt v platforme Profivzdel\xE1vanie.sk spolo\u010Dnosti Poradca podnikate\u013Ea."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "12.1 V\u0161eobecn\xE9 etick\xE9 \u0161tandardy"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kona\u0165 v\u017Edy v s\xFAlade s legislat\xEDvou SR, intern\xFDmi smernicami PP a profesion\xE1lnymi \u0161tandardmi vzdel\xE1vania dospel\xFDch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "komunikova\u0165 otvorene, profesion\xE1lne a bez prejavov nadradenosti alebo manipulat\xEDvneho spr\xE1vania,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Di\u0165 rovnak\xE9 podmienky pre v\u0161etk\xFDch \xFA\u010Dastn\xEDkov bez oh\u013Eadu na vek, pohlavie, zdravotn\xFD stav, n\xE1bo\u017Eenstvo, etnick\xFD p\xF4vod, soci\xE1lne postavenie \u010Di presved\u010Denie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "chr\xE1ni\u0165 dobr\xE9 meno spolo\u010Dnosti Poradca podnikate\u013Ea a platformy Profivzdel\xE1vanie.sk,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "re\u0161pektova\u0165 autoritu garanta vzdel\xE1vania, intern\xFDch metodikov a vedenia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vyh\xFDba\u0165 sa profesion\xE1lnym aj osobn\xFDm konfliktom na pracovisku."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "12.2 \u0160tandardy spr\xE1vania lektora"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poskytova\u0165 odborn\xE9 inform\xE1cie, ktor\xE9 s\xFA presn\xE9, aktu\xE1lne a overen\xE9,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "neprezentova\u0165 osobn\xE9 n\xE1zory ako odborn\xE9 fakty,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pou\u017E\xEDva\u0165 primeran\xE9 didaktick\xE9 met\xF3dy a zabezpe\u010Di\u0165 akt\xEDvne zapojenie \xFA\u010Dastn\xEDkov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vytv\xE1ra\u0165 bezpe\u010Dn\xE9, inkluz\xEDvne, nekonfliktn\xE9 vzdel\xE1vacie prostredie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "reagova\u0165 na podnety \xFA\u010Dastn\xEDkov trpezlivo a s odbornou argument\xE1ciou,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "nevyu\u017E\xEDva\u0165 \u010Das \u0161kolenia na osobn\xFA propag\xE1ciu, marketing alebo predaj produktov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dodr\u017Eiava\u0165 \u010Dasov\xFD harmonogram, term\xEDny, \u0161trukt\xFAru obsahu a organiza\u010Dn\xE9 pokyny,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Di\u0165, aby obsah nebol v rozpore s pr\xE1vnymi predpismi SR."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "12.3 \u0160tandardy spr\xE1vania garanta vzdel\xE1vania"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "vykon\xE1va\u0165 odborn\xFD doh\u013Ead nestranne, vecne a transparentne,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "nezasahova\u0165 do v\xFDu\u010Dby sp\xF4sobom, ktor\xFD by mohol naru\u0161i\u0165 autoritu lektora pred \xFA\u010Dastn\xEDkmi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Di\u0165 pravideln\xFA aktualiz\xE1ciu obsahu pod\u013Ea legislat\xEDvnych zmien,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poskytova\u0165 kon\u0161trukt\xEDvnu sp\xE4tn\xFA v\xE4zbu bez kritiky ad hominem,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "priebe\u017Ene sledova\u0165 kvalitu lektorov a navrhova\u0165 profesijn\xE9 vzdel\xE1vanie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "rie\u0161i\u0165 s\u0165a\u017Enosti \xFA\u010Dastn\xEDkov objekt\xEDvne a s d\xF4razom na fakty."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "12.4 \u0160tandardy administrat\xEDvnej a organiza\u010Dnej podpory"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "poskytova\u0165 presn\xE9 inform\xE1cie pred, po\u010Das a aj po \u0161kolen\xED,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Di\u0165 technick\xE9 podmienky pod\u013Ea \u0161tandardov PP,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "komunikova\u0165 trpezlivo a profesion\xE1lne aj v konfliktn\xFDch situ\xE1ci\xE1ch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dodr\u017Eiava\u0165 princ\xEDpy GDPR a ml\u010Danlivosti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "by\u0165 zodpovedn\xFDm kontaktom pre \xFA\u010Dastn\xEDkov."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "13. Kompeten\u010Dn\xE9 profily"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "Kompeten\u010Dn\xE9 profily predstavuj\xFA minim\xE1lne po\u017Eiadavky pre v\xFDkon jednotliv\xFDch rol\xED v r\xE1mci vzdel\xE1vania."
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "13.1 Lektor \u2013 kompeten\u010Dn\xFD profil"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Odborn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "min. 3 roky odbornej praxe alebo preuk\xE1zate\u013En\xE9 odborn\xE9 znalosti min. 1 rok,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "preh\u013Ead o platnej legislat\xEDve a sektorov\xFDch norm\xE1ch,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "sk\xFAsenosti s v\xFDu\u010Dbou dospel\xFDch (v\xFDhoda)."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Pedagogick\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 vysvetli\u0165 odborn\xFD obsah zrozumite\u013Ene a prakticky,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zvl\xE1danie diskusie, facilit\xE1cie a riadenia skupiny,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pou\u017E\xEDvanie pestr\xFDch didaktick\xFDch met\xF3d."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Osobnostn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "kultivovan\xE1 komunik\xE1cia,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zodpovednos\u0165, spo\u013Eahlivos\u0165,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "\u010Dasov\xFD mana\u017Ement."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "13.2 Garant vzdel\xE1vania \u2013 kompeten\u010Dn\xFD profil"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Odborn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "min. 5 rokov praxe v pr\xEDslu\u0161nej oblasti,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 pos\xFAdi\u0165 odborn\xFA spr\xE1vnos\u0165 obsahu,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "znalos\u0165 legislat\xEDvnych r\xE1mcov v danej oblasti."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Metodick\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 navrhova\u0165 vzdel\xE1vacie programy,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "tvorba syl\xE1b, metodick\xFDch odpor\xFA\u010Dan\xED a v\xFDstupov vzdel\xE1vania."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Osobnostn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "objekt\xEDvnos\u0165, nestrannos\u0165,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schopnos\u0165 poskytova\u0165 profesion\xE1lnu sp\xE4tn\xFA v\xE4zbu."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "13.3 Administrat\xEDvna podpora \u2013 kompeten\u010Dn\xFD profil"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Organiza\u010Dn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "orient\xE1cia v procesoch PP,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "spo\u013Eahliv\xE9 dodr\u017Eiavanie term\xEDnov a presnos\u0165."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Komunika\u010Dn\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "profesion\xE1lna komunik\xE1cia s \xFA\u010Dastn\xEDkmi a lektormi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zvl\xE1danie stresov\xFDch situ\xE1ci\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
        children: "Technick\xE9 kompetencie:"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pr\xE1ca s intern\xFDmi syst\xE9mami,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "z\xE1kladn\xE9 technick\xE9 znalosti vo vz\u0165ahu k online form\xE1m vzdel\xE1vania."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      className: "sectionTitle",
      children: "14. Zodpovednosti jednotliv\xFDch rol\xED"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "14.1 Lektor"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "pripravi\u0165 odborn\xFD obsah v s\xFAlade s metodick\xFDmi po\u017Eiadavkami PP,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "realizova\u0165 \u0161kolenia v s\xFAlade s etick\xFDm k\xF3dexom,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "z\xFA\u010Dast\u0148ova\u0165 sa hodnoten\xED, hospit\xE1ci\xED a pravideln\xFDch superv\xEDzi\xED."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "14.2 Garant"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "schva\u013Eova\u0165 odborn\xFD obsah a jeho aktualiz\xE1cie,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "dohliada\u0165 na v\xFDkon lektora,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "analyzova\u0165 sp\xE4tn\xFA v\xE4zbu a navrhova\u0165 opatrenia."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "sectionTitle",
      children: "14.3 Organiza\u010Dn\xE1 podpora"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "administrat\xEDvne zabezpe\u010Di\u0165 priebeh kurzov,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "spolupracova\u0165 s \xFA\u010Dastn\xEDkmi, garantmi a lektormi,"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        children: "zabezpe\u010Di\u0165 dokument\xE1ciu, techniku a komunik\xE1ciu."
      })]
    })]
  });
};

/* harmony default export */ var EducationalCodeEthics_EducationalCodeEthics = (EducationalCodeEthicsTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(94951);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
;// CONCATENATED MODULE: ./src/pages/eticky-kodex-vzdelavania.tsx










var EducationalCodeEthics = function EducationalCodeEthics() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(EducationalCodeEthics_EducationalCodeEthics, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var eticky_kodex_vzdelavania = (EducationalCodeEthics);

/***/ }),

/***/ 41940:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eticky-kodex-vzdelavania",
      function () {
        return __webpack_require__(81783);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77191:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectDestructuringEmpty; }
/* harmony export */ });
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

/***/ }),

/***/ 90116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(52587);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(28811);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4623,9774,2888,179], function() { return __webpack_exec__(41940); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);